import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import Ticket, { TicketAssignConfig } from '../models/Ticket';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    isFetchingTranslate: false,
    isFetchingConfig: false,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    totalPage: 0,
    orderBy: undefined,
    orderByDesc: false,
    tickets: [],
    myTickets: [],
    ticketAssignConfigs: [],
    ticketAssignConfigParams: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
        totalPage: 0,
        orderBy: undefined,
        orderByDesc: false,
    },
    detail: {
        ticket: new Ticket(),
        myTicket: new Ticket(),
        ticketAssignConfig: new TicketAssignConfig(),
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TICKET_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.TICKET_LIST_SUCCESS:
            return {
                ...state, isFetching: false,
                tickets: action.tickets,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
            };

        case Types.TICKET_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TICKET_DETAIL_SUCCESS:
            return { ...state, isFetchingDetail: false, detail: { ...state.detail, ticket: action.ticket } };

        case Types.TICKET_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TICKET_UPDATE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        // MY TICKET
        case Types.TICKET_MY_LIST_ACTION:
            return { ...state, isFetching: !action.params.noLoading };
        case Types.TICKET_MY_LIST_SUCCESS:
            return { ...state, isFetching: false, myTickets: action.myTickets };

        case Types.TICKET_MY_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TICKET_MY_DETAIL_SUCCESS:
            return { ...state, isFetchingDetail: false, detail: { ...state.detail, myTicket: action.myTicket } };

        case Types.TICKET_MY_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TICKET_MY_UPDATE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        // TICKET ASSIGN CONFIG
        case Types.TICKET_ASSIGN_CONFIG_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.TICKET_ASSIGN_CONFIG_LIST_SUCCESS:
            return {
                ...state, isFetching: false,
                ticketAssignConfigs: action.ticketAssignConfigs,
                ticketAssignConfigParams: {
                    tickets: action.tickets,
                    pageSize: action.pageSize,
                    pageIndex: action.pageIndex,
                    totalCount: action.totalCount,
                    totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
                },
            };

        case Types.TICKET_ASSIGN_CONFIG_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TICKET_ASSIGN_CONFIG_DETAIL_SUCCESS:
            return { ...state, isFetchingDetail: false, detail: { ...state.detail, ticketAssignConfig: action.ticketAssignConfig } };

        case Types.TICKET_ASSIGN_CONFIG_CREATE_ACTION:
            return { ...state, isFetchingConfig: true };
        case Types.TICKET_ASSIGN_CONFIG_CREATE_SUCCESS:
            return { ...state, isFetchingConfig: false };

        case Types.TICKET_ASSIGN_CONFIG_UPDATE_ACTION:
            return { ...state, isFetchingConfig: true };
        case Types.TICKET_ASSIGN_CONFIG_UPDATE_SUCCESS:
            return { ...state, isFetchingConfig: false };

        case Types.TICKET_ASSIGN_CONFIG_DELETE_ACTION:
            return { ...state, isFetchingConfig: true };
        case Types.TICKET_ASSIGN_CONFIG_DELETE_SUCCESS:
            return { ...state, isFetchingConfig: false };

        case Types.TICKET_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false, isFetchingTranslate: false, isFetchingConfig: false, };
        default:
            return state;
    }
}
